<template>
  <el-config-provider :locale="locale">
    <el-container v-if="userName" class="them-default">
      <el-header class="header">
        <i class="logo iconfont icon-pospallogo" />
        <div class="user">hi,{{ userName }}</div>
      </el-header>
      <el-container>
        <el-aside width="96px">
          <el-menu :default-active="index" router>
            <el-menu-item index="/create-project" v-if="otherShow">
              <div class="menu_item" name="title">
                <i class="icon iconfont icon-menu_icon_plan" />
                <span>创建方案</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/drop-data" v-if="otherShow">
              <div class="menu_item" name="title">
                <i class="icon iconfont icon-menu_icon_data" />
                <span>投放情况</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/third-platform" v-if="otherShow">
              <div class="menu_item" name="title">
                <i class="icon iconfont icon-a-menu_icon_otherdata" />
                <span>第三方数据</span>
              </div>
            </el-menu-item>

            <el-menu-item index="/application-config" v-if="applicationShow">
              <div class="menu_item" name="title">
                <i class="icon iconfont icon-menu_icon_app1" />
                <span>应用配置</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/customer-data" v-if="showCustomData">
              <div class="menu_item" name="title">
                <i class="icon iconfont icon-menu_icon_lable" />
                <span>客户数据</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/customer-version" v-if="showCustomData">
              <div class="menu_item" name="title">
                <i class="icon iconfont icon-menu_icon_lable" />
                <span>客户版本 </span>
              </div>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
          <router-view :key="$route.path + $route.query.t"></router-view>
        </el-main>
      </el-container>
    </el-container>
    <div v-else style="width: 100vw; height: 100vh" v-loading="true"></div>
  </el-config-provider>
</template>

<script>
import 'normalize.css/normalize.css'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import { getUserInfo } from './API/user'
import { getToken } from './utils/auth'
export default {
  name: 'App',
  components: {
    [ElConfigProvider.name]: ElConfigProvider
  },
  data () {
    return {
      userName: '',
      showCustomData: true,
      otherShow: true,
      applicationShow: true,
      index: this.$route.hash.split('#')[1],
      token: JSON.stringify(getToken()),
      locale: zhCn
    }
  },
  watch: {
    $route: {
      handler (newData, oldData) {
        console.log('newData', newData)
        console.log('oldData', oldData)
        this.index = newData.path
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true
    }
  },
  async created () {
    const data = await getUserInfo()
    console.log('data', data)
    console.log('JSON.stringify(getToken())', JSON.stringify(getToken()))
    if (!data) {
      this.$confirm('点击确定后返回前一个页面', '当前用户不存在或用户无权限？', {
        confirmButtonText: '确定',
        type: 'error',
        showClose: false,
        closeOnClickModal: false,
        showCancelButton: false
      }).then(() => {
        if (window.history.length > 1) {
          window.history.go(-1)
        } else {
          window.close()
        }
      })
    } else {
      this.userName = data.name
      if (data.roles && data.roles.findIndex(item => item.rolename === '用户画像') !== -1 && data.roles.findIndex(item => item.rolename === '广告管理') === -1) {
        this.showCustomData = true
        this.otherShow = false
        this.$router.push({ path: '/customer-data' })
      }
      if (data.roles && data.roles.findIndex(item => item.rolename === '应用管理') === -1 && data.roles.findIndex(item => item.rolename === '广告管理') === -1) {
        this.applicationShow = false
      } else {
        this.applicationShow = true
      }
    }
  }
}
</script>
<style type="text/css">
@import url("//at.alicdn.com/t/font_2566806_1trwr0pld1p.css");
.el-tabs__active-bar {
  background-color: #2878ff;
}
.el-menu-item.is-active {
  color: #255aff;
}
.el-radio-button.is-active,
.el-radio-button__original-radio:checked + .el-radio-button__inner {
  background: #2878ff !important;
}
.el-button {
  min-height: 32px;
}
.el-date-range-picker .el-button.is-plain {
  background-color: #2878ff;
  color: white;
}
.el-date-range-picker .el-button.is-disabled {
  background-color: #fff !important;
  color: #c0c4cc;
}
.el-button--primary {
  background: #2878ff;
}
.el-input__suffix {
  display: flex;
  align-items: center;
}
@import url("//at.alicdn.com/t/font_2566806_k6c7mzcazlr.css");
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-family: PingFangSC-Regular, sans-serif;
}
</style>
<style lang="less">
.el-menu-item {
  height: auto !important;
}
.el-menu {
  border-right: none;
}
.el-menu::before {
  height: 17px;
}
.el-menu-item.is-active {
  border-left: 2px solid var(--primary);
}
</style>
<style lang="less" scoped>
.header {
  background-color: var(--primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--white);
  height: 48px;
  position: fixed;
  left: 0;
  right: 0;
  .logo {
    font-size: 40px;
  }
  .user {
    font-size: 14px;
  }
}
.el-aside {
  background-color: var(--white);
  box-shadow: 0px 5px 12px 0px #dee7ec;
  min-height: calc(100vh - 48px);
  position: absolute;
  left: 0;
  top: 48px;
  bottom: 0;
}
.el-main {
  background: #f7f7f7;
  position: absolute;
  left: 96px;
  right: 0;
  top: 48px;
  bottom: 0;
}
.menu_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .icon {
    font-size: 36px;
    height: 36px;
    width: 36px;
  }
  span {
    color: var(--regular-text);
    font-size: 14px;
  }
}
.popper {
  width: 180px !important;
  box-sizing: border-box;
}
</style>
